import { render, staticRenderFns } from "./HistoryEvent.vue?vue&type=template&id=1ee54071&scoped=true"
import script from "./HistoryEvent.vue?vue&type=script&lang=ts"
export * from "./HistoryEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee54071",
  null
  
)

export default component.exports